export default ".dx-editor-filled{background-color:rgba(0,0,0,0);height:35px;margin-right:20px}";